export default "__VITE_ASSET__ChZAhFOI__"